import React, { useEffect, useState } from "react";
import { getTodayLesson } from "../api";
import LessonSections from "../components/LessonSections";

export default function TodayLesson() {
  const [lesson, setLesson] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTodayLesson()
      .then((data) => setLesson(data.lesson))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page">Loading today's lesson...</div>;
  if (error) return <div className="page error">{error}</div>;

  return (
    <div className="page">
      <LessonSections lesson={lesson} />
    </div>
  );
}
